import React from "react";
import { NavLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Events from "../../../Analytics/Events";
import SettingsSlidersIcon from "../../../Components/Icons/SettingsSlidersIcon";
import { Tooltip } from "antd";

const StyledNavLink = styled(NavLink)(({ theme }) => ({
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    padding: "6px 8px",
    borderRadius: 8,
    border: "1.5px solid transparent",
    background:
        "linear-gradient(#fff, #fff) padding-box, linear-gradient(186.62deg, #6D72F6 5.2%, #AEB0FA 62.25%, #EEEBFF 135.59%) border-box",
    boxSizing: "border-box",
    boxShadow: "2px 2px 4px 0px #97979740",
    color: "#333",

    "&:hover, &.active:hover": {
        background:
            "linear-gradient(#EFF0FF, #EFF0FF) padding-box, linear-gradient(186.62deg, #4D44D8 5.2%, #AEB0FA 98.6%, #EEEBFF 135.59%) border-box",
        color: "#4D44D8",
        transition: "background-color 120ms ease, border-color 120ms ease",
    },

    "&.active": {
        border: "1.5px solid #4D44D8",
        background: "#fff",
        color: "#4D44D8",
    },

    "& svg": {
        flexShrink: 0,
        width: 20,
        height: 20,
        marginRight: 8,
    },
}));

const NavListItemText = styled("span", {
    shouldForwardProp: (prop) => prop !== "active",
})(({ active }) => ({
    fontFamily: "Roboto, sans-serif",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
    color: active ? "#4D44D8" : "#4E4F6A",
}));

const MenuItem = ({ to, open, textPrimary, mykey }) => {
    const [hovered, setHovered] = React.useState(false);

    return (
        <Tooltip
            placement="right"
            title={open ? null : "Advanced Analysis"}
            zIndex={2000}
        >
            <StyledNavLink
                to={to}
                key={mykey}
                onClick={() => Events("clicked " + textPrimary)}
                className={({ isActive }) => (isActive ? "active" : "")}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                {({ isActive }) => {
                    const isHighlighted = hovered || isActive;
                    return (
                        <>
                            <SettingsSlidersIcon fill={isHighlighted ? "#4D44D8" : undefined} />
                            {open && <NavListItemText active={isActive}>{textPrimary}</NavListItemText>}
                        </>
                    )
                }}
            </StyledNavLink>
        </Tooltip>
    );
};

export default MenuItem;
